// FORM GROUP VALIDATORS
import {UntypedFormGroup} from '@angular/forms';

export function matchFields(fieldKey: string, confirmFiledKey: string) {
  return (group: UntypedFormGroup): {[key: string]: any} | undefined => {
    const field = group.controls[fieldKey];
    const confirmField = group.controls[confirmFiledKey];

    if (field.value !== confirmField.value) {
      const errorObj = {
        mismatchedFields: true
      };

      confirmField.setErrors(Object.assign((confirmField.errors || {}), errorObj));

      return errorObj;
    }

    return undefined;
  };
}
